'use client';

import { useEffect } from 'react';
import { isRTLLanguage } from '@/lib/i18n/config';

export function RTLProvider({ 
  locale, 
  children 
}: { 
  locale: string;
  children: React.ReactNode;
}) {
  const isRTL = isRTLLanguage(locale);
  
  useEffect(() => {
    // Set document direction
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = locale;
    
    // Add RTL font link if needed
    if (isRTL && !document.querySelector('link[href*="Noto+Sans+Arabic"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;500;600;700&family=Vazir:wght@400;500;600;700&display=swap';
      document.head.appendChild(link);
      
      // Update body font family
      document.body.style.fontFamily = "'Vazir', 'Noto Sans Arabic', var(--font-inter), sans-serif";
    } else if (!isRTL) {
      // Reset font family for LTR languages
      document.body.style.fontFamily = '';
    }
  }, [locale, isRTL]);
  
  return <>{children}</>;
}